/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */

import React from 'react';
import Sidebar from '../Sidebar';
import { ListItemStandard } from '@ui5/webcomponents-react';
import { useNavigate } from 'react-router-dom';
import { useTranslations } from '@/hooks/useTranslations';
import { actions } from '@/store/Products';
import { useAppDispatch } from '@/hooks/useAppDispatch';
import { clsx } from '@/utils/utils';

interface NavigableSidebarProps {
    headerText: string;
    currentId: string;
    items: {
        id: string;
        label: string;
    }[];
}

const NavigableSidebar: React.FC<NavigableSidebarProps> = ({ headerText, currentId, items }) => {
    const { t } = useTranslations();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const getIcon = (selectedId: string, currentId: string) => {
        if (selectedId === currentId) {
            return 'initiative';
        }
        return 'circle-task';
    };

    const handleNavigate = (item: any) => {
        dispatch(actions.setCurrentSKU({ SKUId: item.label }));
        navigate(`/monitor/${item.id}`);
    };

    return (
        <Sidebar
            headerText={headerText}
            items={items}
            renderItem={item => (
                <ListItemStandard
                    onClick={() => handleNavigate(item)}
                    icon={getIcon(item.id, currentId)}
                    className={clsx({
                        'list-item-selected': item.id === currentId,
                    })}
                    data-testid="sidebar-item"
                >
                    {t(item.label)}
                </ListItemStandard>
            )}
            maxWidth={464}
        />
    );
};

export default NavigableSidebar;
